(function () {
  if (window.__stickyAtcInit) return;
  window.__stickyAtcInit = true;

  function formatMoney(cents) {
    var format = (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.money_format) || '${{amount}}';
    if (window.Shopify && Shopify.currencyHelper && typeof Shopify.currencyHelper.formatMoney === 'function') {
      return Shopify.currencyHelper.formatMoney(cents, format);
    }
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.iso_code) || 'USD' });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // The main PDP form's <variant-selection> — as opposed to the one inside
  // an open quickshop popup, which uses the exact same product-form.liquid
  // markup and would otherwise be indistinguishable by class/attribute.
  function findMainVariantSelection() {
    var all = document.querySelectorAll('variant-selection');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('.quickshop-modal')) return all[i];
    }
    return null;
  }

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var productId = bar.dataset.stickyAtcProductId;
    var priceAmount = bar.querySelector('[data-sticky-atc-price-amount]');
    var priceCompare = bar.querySelector('[data-sticky-atc-price-compare]');
    var image = bar.querySelector('[data-sticky-atc-image]');
    var button = bar.querySelector('[data-sticky-atc-button]');
    var buttonText = bar.querySelector('[data-sticky-atc-button-text]');
    var translation = (window.PXUTheme && window.PXUTheme.translation) || {};

    // Base product URL (no ?variant=), captured once so each variant change
    // can rebuild the quickshop request URL from a clean starting point.
    var quickshopButton = bar.querySelector('[data-quickshop-button]');
    var quickshopBaseUrl = quickshopButton ? quickshopButton.dataset.quickshopUrl : null;

    function updateFromVariant(variant) {
      if (button) button.disabled = !variant || !variant.available;
      if (buttonText) {
        buttonText.textContent = !variant
          ? (translation.product_unavailable || 'Unavailable')
          : variant.available
            ? (translation.product_add_to_cart || 'Add to cart')
            : (translation.product_sold_out || 'Sold out');
      }

      if (!variant) return;

      if (priceAmount) {
        priceAmount.textContent = formatMoney(variant.price);
      }
      if (priceCompare) {
        priceCompare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      }
      if (image && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        image.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=100';
      }

      // Keep the quickshop popup in sync with whatever variant is actually
      // selected on the PDP form right now — without this it always opens
      // on the product's default/first variant instead.
      if (quickshopButton && quickshopBaseUrl) {
        var sep = quickshopBaseUrl.indexOf('?') > -1 ? '&' : '?';
        quickshopButton.dataset.quickshopUrl = quickshopBaseUrl + sep + 'variant=' + variant.id;
      }
    }

    // Keep the bar's price/availability in sync with the main form's
    // selected variant on load.
    var mainVariantSelectionEl = findMainVariantSelection();
    if (mainVariantSelectionEl && typeof mainVariantSelectionEl.getVariant === 'function') {
      mainVariantSelectionEl.getVariant().then(updateFromVariant);
    }

    document.addEventListener('variant-change', function (event) {
      var detail = event.detail || {};
      var eventProduct = detail.product;

      // Ignore variant-change events for a different product entirely —
      // e.g. a quickshop popup opened from an unrelated "related products"
      // card elsewhere on this same PDP.
      if (productId && eventProduct && String(eventProduct.id) !== productId) return;

      updateFromVariant(detail.variant);

      // If this change came from an open quickshop popup for this same
      // product, mirror the new selection back onto the main PDP form —
      // picking a different variant inside the popup should be reflected
      // on the page once it's closed, not silently discarded.
      var firedFromQuickshop = event.target && event.target.closest && event.target.closest('.quickshop-modal');
      if (firedFromQuickshop && mainVariantSelectionEl && event.target !== mainVariantSelectionEl && detail.variant) {
        var quickshopOptions = event.target.querySelector('options-selection');
        var mainOptions = mainVariantSelectionEl.querySelector('options-selection');
        var newVariantId = detail.variant.id;

        // setSelectedOptions() only updates the swatch/radio UI's visual
        // state — it doesn't touch the main variant-selection's own current
        // variant, so price/ATC there wouldn't otherwise update. Setting
        // .variant directly covers that regardless of whether a swatch UI
        // was found to sync visually first.
        if (quickshopOptions && mainOptions && typeof quickshopOptions.getSelectedOptions === 'function') {
          quickshopOptions.getSelectedOptions().then(function (selectedOptions) {
            if (selectedOptions) mainOptions.setSelectedOptions(selectedOptions);
            mainVariantSelectionEl.variant = newVariantId;
          });
        } else {
          mainVariantSelectionEl.variant = newVariantId;
        }
      }
    });

    // Rating is server-rendered in the snippet from product.metafields.yotpo,
    // which Yotpo only writes now and then and can lag the live review count
    // (e.g. bar showed 208 while the Yotpo reviews widget showed 214). The
    // hidden star-rating widget in this bar is rendered live by Yotpo, and
    // product-card-ratings.js turns it into a "score (count)" text node - so
    // mirror that into the visible rating once it appears. The server value
    // stays as the no-JS / Yotpo-unavailable fallback.
    (function syncLiveRating() {
      var scoreEl = bar.querySelector('.sticky-atc__rating-score');
      var countEl = bar.querySelector('.sticky-atc__rating-count');
      var live = bar.querySelector('.product-thumbnail__rating--yotpo');
      if (!scoreEl || !countEl || !live) return;

      function sync() {
        var textEl = live.querySelector('.voyager-yotpo-rating-text');
        var m = textEl && textEl.textContent.match(/(\d+(?:\.\d+)?)\s*\(\s*(\d[\d,]*)\s*\)/);
        if (!m) return;
        var count = '(' + m[2].replace(/,/g, '') + ')';
        if (countEl.textContent !== count) countEl.textContent = count;
        if (scoreEl.textContent !== m[1]) scoreEl.textContent = m[1];
      }

      sync();
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(sync).observe(live, { childList: true, subtree: true, characterData: true });
      }
    })();

    // Wire the button to open the real quickshop popup — the same one used
    // by product cards — rather than reimplementing it. ProductThumbnail's
    // constructor finds [data-quickshop-button] on this element and, via
    // its own closure, constructs a real ProductQuickshop against it, so
    // the popup gets the theme's actual gallery/variant sync/add-to-cart
    // behavior for free.
    if (window.PXUTheme && typeof window.PXUTheme.ProductThumbnail === 'function') {
      try {
        new window.PXUTheme.ProductThumbnail(bar, {});
      } catch (e) {
        // Quickshop wiring unavailable — leave the button as a plain link fallback.
      }
    }

    // Show the bar the instant the add-to-cart BUTTON itself scrolls past
    // the top of the viewport — deliberately not [data-atc-wrapper], which
    // also wraps the Shop Pay dynamic checkout button, payment terms, and
    // the store-pickup widget, all adding height below the actual button
    // and delaying the trigger well past what "scrolled past add to cart"
    // should mean. Not merely "out of view" either, which would also fire
    // while it's still below the fold and hasn't been reached yet (e.g.
    // above a tall gallery on mobile). No rootMargin buffer: that shrinks
    // the visible region and only delays the switch further.
    var sourceSelector = bar.dataset.stickyAtcSource || '[data-product-atc]';
    var sourceEl = document.querySelector(sourceSelector);

    if (sourceEl && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('sticky-atc--visible', scrolledPast);
        });
      }, { rootMargin: '0px', threshold: 0 });
      observer.observe(sourceEl);
    } else {
      // No main button to track (e.g. quickshop) or no IntersectionObserver support — stay hidden.
      bar.classList.remove('sticky-atc--visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
